import Vue from 'vue'
export const setItineraries = (state, payload) => {
  payload.forEach((newItinerary) => {
    let itineraryIndex = state.itineraries.findIndex((oldItinerary) => oldItinerary.itineraryID === newItinerary.itineraryID)
    if (itineraryIndex < 0) {
      // add it if it doesn't exist
      state.itineraries.push(newItinerary)
    } else {
      // replace everything except campsite Bookings
      Vue.set(state.itineraries, itineraryIndex, {
        ...state.itineraries[itineraryIndex],
        ...newItinerary
      })
    }
  })
}
export const setCampsiteBookings = (state, payload) => {
  let itineraryIndex = state.itineraries.findIndex((itinerary) => itinerary.itineraryID === payload.itineraryID)
  // if we have campsiteBookings put em in
  if (payload.campsiteBookings.length) {
    Vue.set(state.itineraries, itineraryIndex, {
      ...state.itineraries[itineraryIndex],
      campsiteBookings: payload.campsiteBookings
    })
  } else {
    // no campsite bookings, then throw it away
    Vue.delete(state.itineraries, itineraryIndex)
  }
  // make this change to working itinerary too
  Vue.set(state.itinerary, 'campsiteBookings', payload.campsiteBookings)
}
export const setItinerary = (state, payload) => {
  state.itinerary = payload[0]
}
